import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=6aa809b0&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailsModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DetailsModal.vue?vue&type=style&index=0&id=6aa809b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa809b0",
  null
  
)

export default component.exports